import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDetailAccordion',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as { title: string };



const expanded = ref(false);

const handleToggle = (event: Event) => {
	TrackingHelper.trackEvent('userinteraction', {
		label: props.title?.replaceAll(' ', '-').toLowerCase(),
		action: expanded.value ? 'collapsed' : 'expanded',
	});

	const details = event.target as HTMLDetailsElement;
	expanded.value = details.open;
};

return { __sfc: true,props, expanded, handleToggle }
}

})